import { UserPermission } from 'api';

type UserHasAccessTypeProps = {
  permissions: UserPermission[],
  userId: number,
  accessType: string,
  objectType: string,
  objectId: number,
};
const userHasAccessType = ({ permissions, userId, accessType, objectType, objectId }: UserHasAccessTypeProps) => {
  const matchingPermission = permissions?.find(
    perm =>
      perm.user_id?.toString() === userId.toString()
      && perm.feature_object?.object_id === objectId
      && perm.feature_object?.object_type === objectType
      && perm.access_type === accessType
  );

  return !!matchingPermission;
};

export default userHasAccessType;
